import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useUser } from '../context/UserContext';

const parseFirestoreTimestamp = (ts) => {
  if (!ts) return null;
  if (typeof ts.toDate === 'function') return ts.toDate();
  if (typeof ts.seconds === 'number') return new Date(ts.seconds * 1000);
  if (typeof ts._seconds === 'number') return new Date(ts._seconds * 1000);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { userInfo, userLoading } = useUser();
  const firebaseUser = auth.currentUser;

  const isExpiredDemo = (() => {
    if (userInfo?.userType !== 'demo' || !userInfo.expiresAt) return false;
    const expiresAt = parseFirestoreTimestamp(userInfo.expiresAt);
    return expiresAt ? expiresAt < new Date() : false;
  })();

  const isUnknownUser =
    !userLoading &&
    !!firebaseUser &&
    userInfo !== null &&
    userInfo?.userType !== 'demo' &&
    userInfo?.userType !== 'admin';

  // Sign-outs must happen in useEffect, not during render
  useEffect(() => {
    if (isExpiredDemo || isUnknownUser) {
      signOut(auth);
    }
  }, [isExpiredDemo, isUnknownUser]);

  console.log('[ProtectedRoute] userLoading:', userLoading, 'firebaseUser:', firebaseUser?.uid || 'null', 'userInfo:', userInfo?.userType || 'null', 'emailVerified:', firebaseUser?.emailVerified);

  if (userLoading) {
    return <div>Loading...</div>;
  }

  // Not authenticated at all
  if (!firebaseUser) {
    return <Navigate to="/login" />;
  }

  // Authenticated but userInfo still being fetched (e.g. after token refresh/reload)
  // Prevent premature redirect to /login while the fetch is in-flight
  if (!userInfo) {
    return <div>Loading...</div>;
  }

  // Demo user — check email verified + expiry
  if (userInfo?.userType === 'demo') {
    if (!firebaseUser.emailVerified) {
      return <Navigate to="/verify-email" />;
    }
    if (isExpiredDemo) {
      return <Navigate to="/login?expired=true" />;
    }
    return children;
  }

  // Admin — full access
  if (userInfo?.userType === 'admin') {
    return children;
  }

  // Unknown / franchisee → sign out (via useEffect above) + redirect
  return <Navigate to="/login" />;
};

export default ProtectedRoute;

